import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppSettings } from '../library/app-settings';
import { UFWindow } from '@models/unifocus/UFWindow.Interface';

@Injectable()
export class UFBootstrapService {
  private window: UFWindow;
  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.window = this.document.defaultView as any;
  }

  bootstrapApplicationEnvironment(): Promise<void> {
    if (!this.window.unifocus || !AppSettings.EnableUnifocusSSO) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      this.window.unifocus.initializeEnvironment(() => {
        resolve();
      });
    });
  }

  userLogout() {
    this.window.unifocus && this.window.unifocus.signOut(window.location.origin);
  }

  isRunningInIframe(): boolean {
    return this.window.location !== this.window.parent.location;
  }

  isRunningInSingularity(): boolean {
    return this.window.name === 'singularity-iframe';
  }
}

